<template>
	<div class="ClientChat">
		<div class="bntGroup">
			<base-button @click="GoBack()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>
		<card card-body-classes="table-full-width">
		<tabs type="primary"
			:activeTab="value"
            tabContentClasses="tab-opt"
            centered
            inline
            round
			@change="OnTabChange"	
            class="card card-plain mt-3" 
		>
			<tab-pane id="whatsapp">
				<span slot="label" class="tab-label">
					<i class="tab-icon tim-icons icon-chat-33"></i>
					<span>Чат WhatsApp</span>
				</span>				
				<div>	
					<!-- <h3 class="d-md-flex d-lg-none justify-content-center text-center mb-3">{{cat.descr}}</h3> -->
					<h4 class="text-center" v-if="whatsapp_contact == ''"> Для запуска чата с клиентом и отображения сообщений перейдите в редактирование клиента и добавьте в контакты нужный Вам мессенджер</h4>	
					<!-- <div class="row px-3" v-for="contact in client_contacts" :key="contact.contact_id">
						<ReClientChatNest v-if="contact.contact_type !='' && contact.contact_type == '41'" 
						:contact="contact.contact_value" 
						:contactType="contact.contact_type"
						:client_id="client_id" />
					</div>	  v-if="whatsapp_contact !=''" -->
					<div class="row px-3" v-if="whatsapp_contact !=''">
						<ReClientChatNest 
						:contact="whatsapp_contact.contact_value" 
						:contactType="whatsapp_contact.contact_type"
						:client_id="client_id" 
						:client_name="client_name" 
						/>
					</div>	
								
				</div>
			</tab-pane>
			<!-- <tab-pane id="other">
				<span slot="label" class="tab-label">
					<i class="tab-icon tim-icons icon-atom"></i>
					<span>Soon...</span>
				</span>				
				<div>	
					<h4 class="text-center">Чат в разработке</h4>	
				</div>
			</tab-pane> -->

        </tabs>

			
	
			
				<!-- <Pagination :class="[{'': parseInt(history_total) > 0}, {'d-none': parseInt(history_total) < 1}]"
					:type="'primary'" 
					:total="parseInt(history_total)" 
					:perPage="parseInt(20)" 
					:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
					:pClick="pClick">
				</Pagination> -->

			
			
		</card>
	</div>
</template>
<script>

// import Pagination from 'src/our_components/RePagination';
import { TabPane, Tabs } from 'src/components';
import ReClientChatNest from "src/our_components/ReClientChatNest.vue";


export default {
	name: 'Client_chat-page',
	components: {
		// Pagination,
		TabPane, 
		Tabs,
		ReClientChatNest,

	},
	data() {
		return {
			clientInfo: [],
			clientchat_total:0,
			client_id: '',
			client_name: '',
			client_contacts:[],
			whatsapp_contact:'',
			// client_contact_types:[{40:'telegram'}, {41:'whatsapp'}, {42:'Viber'}, {43:'Skype'}],
			// objGetParams: {},
			value: 'whatsapp', 
			
		};
	},
	methods: {
		getClientId(){
			const client_id = typeof this.$route.params.client_id == 'undefined'?'':this.$route.params.client_id;
			this.client_id = client_id;
		},
		getClientContacts(){
			// const client_id = typeof this.$route.params.client_id == 'undefined'?'':this.$route.params.client_id;
			this.$GVO.ApiCall('GET_CONTAKCS',{obj:'client',flt:{id:this.client_id}})
			.then((objApi) => {
				this.client_contacts = [];
				// this.history_total = 0;
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.client_contacts = objApi.data;
						//console.log(this.client_contacts);
						let origPhone = '';
						// this.client_id = typeof this.$route.params.client_id == 'undefined'?'':this.$route.params.client_id;
						for (let i = 0; i < this.client_contacts.length; i++) {
							if(this.client_contacts[i].contact_type == '1') origPhone = this.$GVO.unlinkObject(this.client_contacts[i]);
							if(this.client_contacts[i].contact_type == '41') {
								this.whatsapp_contact = this.client_contacts[i];
								// console.log(this.whatsapp_contact);
							}
						}
						if(this.whatsapp_contact == '' && origPhone != ''){
							this.whatsapp_contact = origPhone;
							this.whatsapp_contact.contact_group = "messanger";
							this.whatsapp_contact.contact_type = "41";
						}
						// if(objApi.total!=undefined) { this.history_total=objApi.total; }
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		getClientInfo(){
			this.$GVO.ApiCall('GET',{obj:'client',flt:{id:this.client_id, only_client: 1,}})
			.then((objApi) => {
				this.client_contacts = [];
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.clientInfo = objApi.data;
						this.client_name = this.clientInfo[0].fio;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},

		// getChat(){
			// this.objGetParams = this.$GVO.GetAllGet();
			// const client_id = typeof this.$route.params.client_id == 'undefined'?'':this.$route.params.client_id;
			// this.$GVO.ApiCall('GET_HISTORY',{obj:'client',flt:{id:client_id}})
			// .then((objApi) => {
			// 	this.masHistory = [];
			// 	this.history_total = 0;
			// 	if(objApi.success === true){
			// 		if(objApi.data.length > 0){
			// 			this.masHistory = objApi.data;
			// 			if(objApi.total!=undefined) { this.history_total=objApi.total; }
			// 		}
			// 	}
			// }).catch(errorObjApi => console.log(errorObjApi));
		// },
		// pClick(e){
		// 	this.objGetParams['p'] = parseInt(e);
		// 	let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
		// 	this.$router.push({path: location.pathname+'?'+strItogGetParams});

		// 	this.getChat();
		// },		
		GoBack(){
			// this.$router.back();
			this.$router.push({path: '/data/clients/id/'+this.$route.params.client_id});
		},
		OnTabChange(strTabId){
			this.$emit('input', strTabId);
			this.$emit('change', strTabId);
		},

	},
	mounted() {
		this.getClientId();
		this.getClientContacts();
		this.getClientInfo();
		
	}
};
</script>
<style scoped>
	.ClientChat .bntGroup{
		position: absolute;
		z-index: 1;
		right: 40px;
	}
	.ClientChat >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
	.ClientChat >>> .tab-content {margin-top: 15px;}
	.ClientChat >>> .tab-space {padding: 20px 0px 0px 0px;}
	.ClientChat >>> .messicon {
		width: 18px;
		height: 18px;
		display: inline-block;
		margin-top: 8px;
	}
	.ClientChat >>> .messicon-telegram {background: url('/img/icons/telegramlogo.svg') no-repeat; }
	.ClientChat >>> .messicon-whatsapp {background: url('/img/icons/whatsapplogo.svg') no-repeat; }
	.ClientChat >>> .messicon-viber {background: url('/img/icons/viberlogo.svg') no-repeat; }
	.ClientChat >>> .messicon-skype {background: url('/img/icons/skypelogo.svg') no-repeat; }
	
</style>
